module.exports = __webpack_public_path__ + "static/imgs/chart-bg.75c5764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/chart-bg.png
// module id = 1pdt
// module chunks = 1